import { useMutation } from 'react-query';

//services
import { signUp } from 'modules/account/features/singup/api';

interface IProps {
  registerUser: (email: string, formValues: any) => void;
}

export const useMutationSignUp = ({ registerUser }: IProps) => {
  const { mutate, status, error } = useMutation(signUp, {
    onSuccess: (data, variables) => {
      registerUser(data.email, variables);
    },
  });

  return { mutate, status, error };
};
